import { Controller } from "@hotwired/stimulus"

// Confirmación discreta del país inferido (TC-134-1.7.1.2, US-134-1.7.1).
//
// El servidor manda el selector ABIERTO y el "(cambiar)" oculto, para que la pieza
// siga sirviendo sin JavaScript. Este controlador invierte los dos al conectar y
// deja la forma discreta de la maqueta —"España · ¿No eres de España? (cambiar)"—;
// pulsar "(cambiar)" vuelve al selector y esconde la línea del país, que es lo que
// pide la US. El separador `·` viaja con el "(cambiar)": oculto sin JavaScript para
// que la línea no acabe en un punto colgando.
//
// Si no hay línea que confirmar —cuenta sin país soportado, ver el partial— no
// hay nada que cerrar: el selector se queda como llegó.
//
// El "Guardar" solo existe donde la pieza se pinta con `autoguardado` —la home
// (TC-134-1.7.1.4), que no tiene ningún "Continuar" al que agarrarse—, y se
// esconde aquí porque con JavaScript elegir país ya envía el formulario.
export default class extends Controller {
  static targets = ["resumen", "separador", "cambiar", "selector", "guardar"]

  connect () {
    if (this.hasGuardarTarget) this.guardarTarget.hidden = true

    if (!this.hasResumenTarget) return

    this.separadorTarget.hidden = false
    this.cambiarTarget.hidden = false
    this.selectorTarget.hidden = true
  }

  cambiar () {
    this.resumenTarget.hidden = true
    this.selectorTarget.hidden = false

    // El foco viaja con el control que aparece: quien llegó al "(cambiar)" con el
    // teclado se queda si no, tabulando desde un botón que acaba de desaparecer.
    this.selectorTarget.querySelector("select").focus()
  }

  // Elegir país ES guardar. La acción se declara en el elemento del controlador y
  // no en el `select` —el `change` burbujea— para que el partial no tenga que
  // saber quién lo contiene.
  //
  // `requestSubmit` y no `submit()`: dispara el evento `submit` del formulario, con
  // lo que la validación y cualquier oyente siguen funcionando.
  envia () {
    this.element.closest("form")?.requestSubmit()
  }
}
